/**
 * Columnar format for forms - holds form sections generally
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Grid as SemanticGrid } from '@adc/ui-core'
import classnames from 'classnames/bind'
import constants from '../constants'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const FormColumn = ({
  children,
  colSize,
  className,
  fill,
  verticalCollapse,
  ...rest
}) => {
  let colSizing = constants.FORM_COL_SIZING
  if (colSize === 'narrow') {
    colSizing = constants.FORM_TWO_COLS_NARROW_SIZING
  } else if (colSize === 'wide') {
    colSizing = constants.FORM_TWO_COLS_WIDE_SIZING
  } else if (colSize === 'half') {
    colSizing = constants.FORM_TWO_COLS_SIZING
  } else if (colSize === 'full') {
    colSizing = constants.FORM_COL_FULL_SIZING
  } else if (colSize instanceof Object) {
    colSizing = colSize
  }

  return (
    <SemanticGrid.Column
      className={cx(
        'form-column',
        { 'form-column--fill': fill, 'vertical-collapse': verticalCollapse },
        className
      )}
      {...colSizing}
      {...rest}
    >
      {children}
    </SemanticGrid.Column>
  )
}

FormColumn.propTypes = {
  ...SemanticGrid.Column.propTypes,
  colSize: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.oneOf(['even', 'narrow', 'wide', 'half', 'full']),
  ]),
  fill: PropTypes.bool,
  verticalCollapse: PropTypes.bool,
}

export default FormColumn
